'use client'

import React, { useEffect, useState } from 'react'
import { CheckCircle, Clock, FileText, GraduationCap, User } from 'lucide-react'
import { useNavigate, useParams } from 'react-router-dom'
import { getExamData } from './api'

export default function ExamInstructionsPage() {
  const [isChecked, setIsChecked] = useState(false)
  const [ examInstruction , setExamInstruction ] = useState();
  const [ examData, setExamData ] = useState()

  const navigate = useNavigate();
  
  const { id } = useParams();
  const studentData = localStorage.getItem("studentData");
  
  const handleStartExam = () => {
    if (isChecked) {
      console.log("Starting exam...")
      alert("Exam is starting. Good luck!")
      navigate(`/exam/start/examId`);
    }
  }

  useEffect(() => {
    const fetchExamData = async () => {
        const examData = await getExamData(id);
        console.log(examData);
        setExamData(examData);
        localStorage.setItem('examData', JSON.stringify(examData));
        setExamInstruction(examData.instructions)
    }

    fetchExamData();
  }, [id])

  return (
    <div className="flex min-h-screen bg-gradient-to-b from-blue-50 to-white">
       <aside className="w-80 border-r hidden lg:block bg-white p-6 overflow-y-auto">
      <div className="bg-white rounded-lg shadow-sm p-6">
        <h2 className="text-xl font-semibold mb-4">Exam Information</h2>
        <div className="space-y-4">
          <div className="flex items-center space-x-3">
            <FileText className="h-5 w-5 text-blue-500" />
            <div>
              <p className="text-sm font-medium">Exam Name</p>
              <p className="text-xs text-gray-500">{examData?.exam_topic}</p>
            </div>
          </div>
          <div className="flex items-center space-x-3">
            <Clock className="h-5 w-5 text-blue-500" />
            <div>
              <p className="text-sm font-medium">Duration</p>
              <p className="text-xs text-gray-500">{examData?.examDuration}</p>
            </div>
          </div>
          <div className="flex items-center space-x-3">
            <User className="h-5 w-5 text-blue-500" />
            <div>
              <p className="text-sm font-medium">Candidate</p>
              <p className="text-xs text-gray-500">{studentData?.studentName}</p>
            </div>
          </div>
          <div className="flex items-center space-x-3">
            <GraduationCap className="h-5 w-5 text-blue-500" />
            <div>
              <p className="text-sm font-medium">Subject</p>
              <p className="text-xs text-gray-500">Mathematics</p>
            </div>
          </div>
        </div>
      </div>
    </aside>
      <main className="flex-1 overflow-y-auto p-8">
        <h1 className="text-4xl font-bold text-blue-800 mb-4">Exam Instructions</h1>
        <p className="text-xl text-gray-600 mb-12">Please read the following instructions carefully before starting the exam:</p>

        <div className="bg-white rounded-lg shadow-lg p-6 mb-12">
          <h2 className="text-2xl font-semibold text-blue-700 mb-4 flex items-center">
            <Clock className="mr-2" /> During the Exam
          </h2>
          <ul className="space-y-3">
            {examInstruction?.map((instruction, index) => (
              <li key={index} className="flex items-start">
                <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" />
                <span>{instruction}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="flex items-center space-x-2 mb-6">
          <input 
            type="checkbox" 
            id="terms" 
            checked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
          />
          <label
            htmlFor="terms"
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            I hereby confirm that I have read and understood all the exam instructions
          </label>
        </div>

        <button 
          onClick={handleStartExam} 
          disabled={!isChecked}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-full transition duration-300 ease-in-out transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Start Exam
        </button>
      </main>
    </div>
  )
}

